"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var EditorText_1 = __importDefault(require("./EditorText"));

var EditorChildren_1 = __importDefault(require("./EditorChildren"));

var style = {
  WebkitUserModify: 'read-write-plaintext-only',
  position: 'relative',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word'
};

function EditorBlock(props) {
  var _block = props.block,
      mapBlock = props.mapBlock,
      renderProps = __rest(props, ["block", "mapBlock"]);

  var RenderBlock = renderProps.renderBlock;
  var block = _block;

  if (mapBlock != null) {
    block = mapBlock(_block);
  }

  var htmlAttrs = {
    'data-block-key': block.blockKey,
    'data-fragment-start': 0,
    'data-fragment-end': block.value.length,
    style: style
  };
  var _block2 = block,
      entity = _block2.entity;

  if (entity != null && entity.isAtomic && RenderBlock != null) {
    var offset = 0;
    return react_1.default.createElement(RenderBlock, {
      block: block,
      key: "".concat(block.blockKey, "-").concat(offset),
      htmlAttrs: htmlAttrs,
      children: react_1.default.createElement(react_1.default.Fragment, null, "null")
    });
  }

  var content = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(EditorText_1.default, Object.assign({
    key: "block-text",
    mapBlock: props.mapBlock,
    block: block
  }, renderProps)), props.block.blocks.length > 0 && react_1.default.createElement(EditorChildren_1.default, Object.assign({
    blocks: props.block.blocks
  }, renderProps)));

  if (RenderBlock != null) {
    return react_1.default.createElement(RenderBlock, {
      htmlAttrs: htmlAttrs,
      block: block
    }, content);
  }

  return content;
}

exports.default = EditorBlock;